// extracted by mini-css-extract-plugin
export var darkMode = "_1f-0";